import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import BlockHeader from '../shared/BlockHeader';

export default function BlockCategories({ title, categories }) {
    const categoriesList = categories.slice(0, 6).map((category, index) => (
        <div key={index} className="category-card">
            <Link to={category.url} className="category-card__link">
                <div className="category-card__image">
                    <img 
                        src={category.image}
                        alt={category.name} 
                    />
                </div>
                <div className="category-card__name">
                    <FormattedMessage 
                        id={`categories.${category.translationKey}`} 
                        defaultMessage={category.name}
                    />
                </div>
            </Link>
        </div>
    ));

    return (
        <div className="block block-categories">
            <div className="container">
                <BlockHeader title={
                    <FormattedMessage 
                        id="categories.title" 
                        defaultMessage={title}
                    />
                } />
                <div className="block-categories__grid">{categoriesList}</div>
            </div>
        </div>
    );
}

BlockCategories.propTypes = {
    title: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            translationKey: PropTypes.string
        })
    ),
};

BlockCategories.defaultProps = {
    categories: [],
};
